// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { UpdateAvailableToast } from "@/components/layout/update-available-toast";
import { Toaster } from "@/components/ui/sonner";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="h-screen overflow-hidden bg-background text-foreground">
      <Outlet />
      <Toaster />
      <UpdateAvailableToast />
    </div>
  );
}
